
<!-- Modal -->
<div class="modal fade" *ngIf="adminApi.isLoggedIn()" id="{{modalid}}" tabindex="-1" aria-labelledby="suggestskillModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <form class="" [formGroup]="Form" (ngSubmit)="onSubmit(Form)" enctype="multipart/form-data">
        <div class="modal-body pt-4">
          <h5 class="card-title">{{video?  "Edit Video": "New Video"}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          <div class="form-group">
              <label class="form-label">Video Name</label>
              <input type="text" class="form-control" formControlName="name">
              <div class="invalid-feedback d-block"
                  *ngIf="f2['name'].errors?.['required'] && (f2['name'].dirty || f2['name'].touched)">
                  Please fill name.
              </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label d-block">Video</label>
                <input type="file" #fileUploader formControlName="video" accept="video/mp4,video/3gp" (change)="onSelectFile($event)">
                <div class="invalid-feedback d-block"
                    *ngIf="f2['video'].errors?.['required'] && (f2['video'].dirty || f2['video'].touched)">
                    Please select mp4 or 3gp video.
                </div>
                <br *ngIf="videourl"/>
                <br *ngIf="videourl"/>
                <video oncontextmenu="return false;" controlsList="nodownload" [src]="videourl" *ngIf="videourl" height="100" controls></video> 
                <br/>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label d-block">Thumbnail</label>
                <input type="file" formControlName="thumbnail" accept="image/jpg,image/jpeg,image/png" (change)="onSelectFile($event)">
                <div class="invalid-feedback d-block"
                    *ngIf="f2['thumbnail'].errors?.['required'] && (f2['thumbnail'].dirty || f2['thumbnail'].touched)">
                    Please select png, jpeg or jpg image.
                </div>
                <br *ngIf="imageurl"/>
                <br *ngIf="imageurl"/>
                <img [src]="imageurl" *ngIf="imageurl" height="100">
                <br/>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">Sort Order</label>
            <input type="text" class="form-control" formControlName="sort" [numbersOnly]="true">
            <div class="invalid-feedback d-block"
                *ngIf="(f2['sort'].errors?.['required'] || f2['sort'].errors?.['pattern']) && (f2['sort'].dirty || f2['sort'].touched)">
                Please fill numeric value only.
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">Description</label>
            <editor
              id="editor"
              formControlName="description"
              [init]="{ plugins: 'lists link image table code help wordcount' }"
              (onInit)="handleEvent($event)"
            ></editor>
          </div>
          <div class="form-group">
            <label class="form-label">Signature Series</label>
            <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" formControlName="signatureseries" title="Select signature series" class="selectpicker category font-oswald w-100">
              <option *ngFor="let selectcategory of allsignatureseries" [value]="selectcategory?.id">{{selectcategory?.title | titlecase}}</option>
            </select>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">Featured</label>
                <div>
                  <label class="toggle-switch">
                    <input type="checkbox" formControlName="is_featured">
                    <div class="toggle-slider"></div>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label">Trailer</label>
                <div>
                  <label class="toggle-switch">
                    <input type="checkbox" formControlName="is_trailor">
                    <div class="toggle-slider"></div>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <br/>
        </div>
        
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary me-3" data-bs-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-dark btn-gold">Submit <i *ngIf="submitting" class="fa fa-spinner fa-spin"></i></button>
        </div>
      </form>
    </div>
  </div>
</div>